import React from "react";

import { LayoutController } from "layouts/LayoutController";
import { Switch } from "react-router-dom";

import { MagicLink } from "app/account/MagicLink/MagicLink";
import { CheckYourInbox } from "app/account/Password/CheckYourInbox";

import { SimpleRoute } from "../../app/AppRoute";
import { SignOutEverywhere } from "../../app/account/SignOutEverywhere";
import { SsoErrorUnableToLookupOds } from "../../app/account/SsoFailedErrors/SsoErrorUnableToLookupOdsPage";
import { SsoFailed } from "../../app/account/SsoFailedErrors/SsoFailedErrorPage";
import { SsoErrorNoOdsCode } from "../../app/account/SsoFailedErrors/SsoNoOdsCodeErrorPage";
import { DeletedPage } from "../../app/deletedPage/DeletedPage";
import { PUBLIC_ROUTES } from "../../shared/Routes";

/**
 * A group of React Router routes that both authenticated and unauthenticated users can access,
 * plus redirects for the public routes.
 */
export const PublicRoutes = () => {
    return (
        <LayoutController>
            <Switch>
                <SimpleRoute
                    path={PUBLIC_ROUTES.patient_message_history}
                    component={DeletedPage}
                    exact
                />
                <SimpleRoute
                    path={PUBLIC_ROUTES.userSignoutConfirm}
                    component={SignOutEverywhere}
                    exact
                />
                <SimpleRoute
                    path={PUBLIC_ROUTES.sso_failed}
                    component={SsoFailed}
                    exact
                />
                <SimpleRoute
                    path={PUBLIC_ROUTES.noOdsCode}
                    component={SsoErrorNoOdsCode}
                    exact
                />
                <SimpleRoute
                    path={PUBLIC_ROUTES.unableToLookupOds}
                    component={SsoErrorUnableToLookupOds}
                    exact
                />
                <SimpleRoute
                    path={PUBLIC_ROUTES.magicLink}
                    component={MagicLink}
                    exact
                />
                <SimpleRoute
                    path={PUBLIC_ROUTES.checkYourInbox}
                    component={CheckYourInbox}
                    exact
                />
            </Switch>
        </LayoutController>
    );
};
